import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { LockGlyph12Icon } from 'assets/icons'

const avatarSize = '30px'

const GroupListItemCard = ({
   coverMedia,
   dateAdded,
   linkTo,
   members,
   name,
   numMembers,
   privacy,
   subtitle,
   textColor
}) => (
   <Link to={linkTo}>
      <View position="relative">
         <View
            width="100%"
            paddingTop="56.25%"
            backgroundColor="#eee"
            backgroundImage={coverMedia && `url(${coverMedia?.file.thumbnailUrlW480})`}
            backgroundSize="cover"
            backgroundPosition="center center"
            backgroundRepeat="no-repeat"
            borderRadius="3px"
            marginBottom="15px[a-d] 20px[e-f]"
         />
         <View
            position="relative"
            display="flex"
            padding="0 0 60px 0"
            borderRadius="5px">
            <View flex="1 1 auto">
               <Text
                  size="2.5"
                  lineHeight="120%"
                  weight="medium"
                  color="#222">
                  {name}
               </Text>
               {subtitle && (
                  <View
                     margin="10px 0 5px 0"
                     maxHeight="55px"
                     opacity="0.6"
                     style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        wordBreak: 'break-word'
                     }}>
                     <Text
                        size="2"
                        lineHeight="130%"
                        color={textColor}>
                        {subtitle}
                     </Text>
                  </View>
               )}
               <View marginTop="5px[e-f]" marginBottom="12px">
                  <Text size="2" color="#aaa">
                     {numMembers > 1 && (
                        `${numMembers} Members`
                     )}
                     {(numMembers < 2) && (
                        `Created ${dateAdded}`
                     )}
                  </Text>
               </View>
               {members.map(user => (
                  <View
                     key={user.id}
                     float="left"
                     height={avatarSize}>
                     <View
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        float="left"
                        flex="0 0 auto"
                        width={avatarSize}
                        height={avatarSize}
                        borderRadius="50%"
                        marginRight="-4px"
                        border="2px solid #fff"
                        backgroundColor="#eee"
                        backgroundImage={user.avatarMedia
                           ? `url(${user.avatarMedia.file.thumbnailUrlW48})`
                           : '/assets/images/avatarPlaceholder.svg'
                        }
                        backgroundSize={user.avatarMedia ? 'cover' : '30px 30px'}
                        backgroundPosition="bottom center"
                        style={{ backgroundRepeat: 'no-repeat' }}>
                        {!user.avatarMedia && (
                           <Text
                              size="0.9"
                              color="#888"
                              weight="medium"
                              transform="uppercase">
                              {`${user.firstName.charAt(0)}${user.lastName.charAt(0)}`}
                           </Text>
                        )}
                     </View>
                  </View>
               ))}
               {['admin', 'draft', 'private'].includes(privacy) && (
                  <View
                     display="flex"
                     alignItems="center"
                     position="absolute"
                     bottom="20px"
                     left="0px"
                     backgroundColor={privacy === 'draft'
                        ? 'rgba(247, 183, 124, 1)'
                        : 'rgba(0,0,0,0.3)'
                     }
                     borderRadius="2px"
                     padding="5px 5px">
                     {privacy !== 'draft' && (
                        <View display="flex" alignItems="center" marginRight="5px">
                           <LockGlyph12Icon
                              color="rgba(255,255,255,0.5)"
                              width="7px"
                              height="7px"
                           />
                        </View>
                     )}
                     <Text
                        size="0.7"
                        lineHeight="100%"
                        color={privacy === 'draft' ? '#000' : 'rgba(255,255,255,0.8)'}
                        weight="medium"
                        transform="uppercase">
                        {privacy}
                     </Text>
                  </View>
               )}
            </View>
         </View>
      </View>
   </Link>
)

GroupListItemCard.propTypes = {
   coverMedia: PropTypes.object,
   dateAdded: PropTypes.string.isRequired,
   linkTo: PropTypes.string.isRequired,
   members: PropTypes.array,
   name: PropTypes.string.isRequired,
   numMembers: PropTypes.number.isRequired,
   privacy: PropTypes.string.isRequired,
   subtitle: PropTypes.string,
   textColor: PropTypes.string
}

GroupListItemCard.defaultProps = {
   coverMedia: undefined,
   members: [],
   subtitle: undefined,
   textColor: '#000'
}

export default GroupListItemCard
